<template>
  <v-navigation-drawer v-model="drawer" :clipped="true" temporary :right="true" fixed app lg4>
    <v-layout row>
      <v-flex xs12 sm12>
        <v-card>
          <v-card-title>
            <v-icon>schedule</v-icon>&nbsp;
            Последние действия
          </v-card-title>
          <v-list v-if="countOfNotifications" two-line dense>
            <template v-for="(item, index) in notifications">
              <v-list-item :key="`tile-${item.id}`" avatar ripple @click="showDetails(item)">
                <v-list-item-content>
                  <v-list-item-title>
                    <template v-if="item.active">
                      <strong>{{ item.title }}</strong>
                    </template>
                    <template v-else>
                      {{ item.title }}
                    </template>
                  </v-list-item-title>
                  <v-list-item-sub-title>{{ item.message }}</v-list-item-sub-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>{{ formatDate(item.date) }}</v-list-item-action-text>
                  <v-icon :color="item.active ? 'yellow darken-2' : 'grey lighten-1'">
                    {{ getIcon(item.level) }}
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < notifications.length" :key="`divider-${index}`" />
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RightDrawer',

  props: {
    opened: Boolean
  },

  data: () => ({
    allowedIcons: [
      'info',
      'warning',
      'error',
      'email',
      'message'
    ],

    dateFormatOptions: {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  }),

  computed: {
    ...mapGetters({
      notifications: 'notification/notifications',
      countOfNotifications: 'notification/countOfNotifications'
    }),
    drawer: {
      get: function() {
        return this.opened
      },
      set: function(newValue) {
        this.$emit('update:opened', newValue)
      }
    }
  },

  methods: {
    getIcon(name) {
      const idx = this.allowedIcons.indexOf(name)
      if (idx > -1) {
        return this.allowedIcons[idx]
      }
      return 'message'
    },

    formatDate(date) {
      return date.toLocaleDateString('ru-RU')
    },

    async showDetails(item) {
      if (item.active) {
        await this.$store.dispatch('notification/setNotificationActive', { id: item.id, active: false })
      }
      await this.$store.dispatch('notification/setSystemNotification', { message: item.message, type: item.level })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
